import { Component, ChangeDetectorRef } from '@angular/core'
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'

import { debounceTime } from 'rxjs/operators/debounceTime'

import { AuthProvider } from '../../providers/auth/auth'

import { CondominiumShowPage } from '../../pages/condominium-show/condominium-show'
import { CondominiumWritePage } from '../../pages/condominium-write/condominium-write'
import { DeviceIndexPage } from '../../pages/device-index/device-index'
import { HousingUnitShowPage } from '../../pages/housing-unit-show/housing-unit-show'
import { HousingUnitEditPage } from '../../pages/housing-unit-edit/housing-unit-edit'
import { UserEditPage } from '../../pages/user-edit/user-edit'
import { UserIndexPage } from '../../pages/user-index/user-index'

import { HousingUnit, User, Message, MessageReceiverType, Condominium, Address, AddressType, AddressOwnerType } from '../../models/models'

import { MessageProvider } from '../../providers/message/message'
import { CondominiumIndexPage } from '../condominium-index/condominium-index'
import { UserShowPage } from '../user-show/user-show'
import { Paginator } from '../../models/interfaces'
import { FormControl } from '@angular/forms'
//import { CondominiumProvider } from '../../providers/condominium/condominium';
import { AddressCreatePage } from '../address-create/address-create'
import { AddressProvider } from '../../providers/address/address'
import { Logger } from '../../util/logger/logger'
import { DeviceProvider } from '../../providers/device/device'

@IonicPage()
@Component({
	selector: 'page-control-panel',
	templateUrl: 'control-panel.html',
})
export class ControlPanelPage {
	public condominiumSearchTerm: string = null;
	public condominiumSearchControl: FormControl

	private _condominiumFiltered: Condominium[] = [];
	public get condominiumFiltered(): Condominium[] {
		return this._condominiumFiltered
	}
	public set condominiumFiltered(value: Condominium[]) {
		this._condominiumFiltered = value
		this.detectChanges()
	}


	private _isHousingUnitsLoading: boolean = true;
	public get isHousingUnitsLoading(): boolean {
		return this._isHousingUnitsLoading
	}
	public set isHousingUnitsLoading(value: boolean) {
		this._isHousingUnitsLoading = value
		this.detectChanges()
	}


	private _isCondominiumLoading: boolean = true;
	public get isCondominiumLoading(): boolean {
		return this._isCondominiumLoading
	}
	public set isCondominiumLoading(value: boolean) {
		this._isCondominiumLoading = value
		this.detectChanges()
	}


	private _isCondominiumExpanded: boolean = false;
	public get isCondominiumExpanded(): boolean {
		return this._isCondominiumExpanded
	}
	public set isCondominiumExpanded(value: boolean) {
		this._isCondominiumExpanded = value
		this.detectChanges()
	}


	private _isHousingUnitsExpanded: boolean = true;
	public get isHousingUnitsExpanded(): boolean {
		return this._isHousingUnitsExpanded
	}
	public set isHousingUnitsExpanded(value: boolean) {
		this._isHousingUnitsExpanded = value
		this.detectChanges()
	}

	private _isMessagesExpanded: boolean = false;
	public get isMessagesExpanded(): boolean {
		return this._isMessagesExpanded
	}
	public set isMessagesExpanded(value: boolean) {
		this._isMessagesExpanded = value
		this.detectChanges()
	}

	private _isMessagesLoading: boolean = false;
	public get isMessagesLoading(): boolean {
		return this._isMessagesLoading
	}
	public set isMessagesLoading(value: boolean) {
		this._isMessagesLoading = value
		this.detectChanges()
	}

	public contacts: Address[] = null;
	public contactPaginator: Paginator<Address>
	public messagePaginator: Paginator<Message>

	constructor(
		public auth: AuthProvider,
		private addresses: AddressProvider,
		private changeDetector: ChangeDetectorRef,
		private devices: DeviceProvider,
		//private condominiums: CondominiumProvider,
		//private housingUnits: HousingUnitProvider,
		public messages: MessageProvider,

		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController,
	) {
		console.group('[new ControlPanelPage()]')
		this.condominiumSearchControl = new FormControl()
		console.groupEnd()
	}

	ionViewDidLoad() {
		let self = this

		this.condominiumSearchControl.valueChanges
			.pipe(debounceTime(1000))
			.subscribe(search => {//quando cambia i termini di ricerca aspetta X millisecondi prima di fare un caricamento da web
				console.debug("Filtro condomini: " + search)
				self.applyCondominiumFilter()
			})
	}

	/*
	Aggiorna i dati dell'utente prima di visualizzare il pannello di controllo
	*/
	ionViewWillEnter() {
		this.refresh()
	}

	private applyCondominiumFilter() {
		let self = this

		this.isCondominiumLoading = true
		self.detectChanges()

		let filter = self.condominiumSearchTerm
		if(!filter) {//nessun filtro
			console.info('[ControlPanel.applyCondominiumFilter()] Nessun filtro testuale per i condomini')
			this.condominiumFiltered = this.auth.user.condominiums
		} else {//applica filtro
			console.info('[ControlPanel.applyCondominiumFilter()] Applica filtro testuale ai condomini: "' + filter + '"')
			filter = filter.toLowerCase()
			//se c'è un filtro apre i condomini automaticamente
			this.isCondominiumExpanded = true
			//Assegnando questa proprietà forza il refresh
			this.condominiumFiltered = this.auth.user.condominiums.filter((condominium) => {
				if(!condominium) {
					return false
				}
				if(condominium.name && condominium.name.toLowerCase().indexOf(filter) > -1) {
					return true
				}
				if(condominium.address) {
					if(condominium.address.formatted && condominium.address.formatted.toLowerCase().indexOf(filter) > -1) return true
					if(condominium.address.location && condominium.address.location.name && condominium.address.location.name.toLowerCase().indexOf(filter) > -1) return true
				}
				return false
			})
		}
		this.isCondominiumLoading = false
		self.detectChanges()
	}

	public detectChanges() {
		if(this.changeDetector && !this.changeDetector['destroyed']) {
			this.changeDetector.detectChanges()
			return true
		}
		return false
	}

	/*
	Quando cambiano i termini della ricerca filtra i condomini
	*/
	public onSearchInput() {//Quando cambia i termini di ricerca va immediatamente in loading
		this.applyCondominiumFilter()
	}

	public goToCondominiumShow(condominium) {
		this.navCtrl.push(CondominiumShowPage, { condominium: condominium })
	}

	public goToCondominiumWrite(condominium = null) {
		this.navCtrl.push(CondominiumWritePage, { condominium: condominium })
	}

	public goToCondominiumIndex() {
		this.navCtrl.push(CondominiumIndexPage)
	}

	public goToContactCreate() {
		this.navCtrl.push(AddressCreatePage, {
			user: this.auth.user,
			type: AddressType.CONTACT
		})
	}

	public goToDeviceIndex() {
		this.navCtrl.push(DeviceIndexPage)
	}

	public goToHousingUnitEdit(housingUnit: HousingUnit) {
		this.navCtrl.push(HousingUnitEditPage, { housingUnit: housingUnit })
	}
	public goToHousingUnitShow(housingUnit: HousingUnit) {
		this.navCtrl.push(HousingUnitShowPage, { housingUnit: housingUnit })
	}

	public goToUserEdit() {
		this.navCtrl.push(UserEditPage, { user: this.auth.user })
	}

	public goToUserIndex() {
		this.navCtrl.push(UserIndexPage)
	}

	public goToUserShow() {
		this.navCtrl.push(UserShowPage, { user: this.auth.user })
	}

	public onContactListRefresh(contacts) {
		this.contacts = contacts
	}

	/**
	Aggiorna i dati utente e in coda i messaggi (per non sovrascriverli)
	*/
	public refresh() {
		let self = this

		if(!this.auth.isAuth) {
			console.warn('Pannello di controllo istanziato con utente non autenticato')
			return
		}

		//let messagesBackup = this.auth.user.messages;

		//aggiorna unità immobiliari e condomini
		//this.isCondominiumLoading = true;
		this.isHousingUnitsLoading = true

		this.auth.refresh(['condominiums',
			'condominiums.userRoles',
			'condominiums.housingUnits',
			'condominiums.housingUnits.userRoles',
			'contacts',
			'housingUnits',
			'housingUnits.condominium',
			'housingUnits.condominium.devices',
			'housingUnits.userRoles']).then((user: User) => {
				console.log("[ControlPanel.refresh()] Utente recuperato: ", user)

				self.isHousingUnitsLoading = false

				self.applyCondominiumFilter()


				self.messagePaginator = {
					next(before: Message = null, pagesize: number = 10): Promise<Message[]> {
						console.debug('[ControlPanelPage.messagePaginator.next()] Richiesto il caricamento di ulteriori ' + pagesize + ' messaggi dall\' unità abitativa, a partire da:', before)

						return new Promise<Message[]>((resolve, reject) => {
							self.messages.indexAll(
								self.auth.user.id,
								MessageReceiverType.USER,
								['condominium', 'condominium.userRoles', 'device', 'device.condominium', 'housingUnit', 'housingUnit.userRoles', 'receiver', 'sender'],
								pagesize,
								before
							).then(
								(messages: Message[]) => {
									console.log('Recuperati altri messaggi per dell\' utente: ', messages)
									//self.isMessagesLoading = false;

									resolve(messages)
									//non serve il changeDetector, è già nel componente MessageList
									//self.detectChanges();
								},
								(error) => {
									console.error("Errore recuperando i messaggi dell\' utente:", error)
									reject(error)
								}
							)
						})
					}
				}

				self.contactPaginator = {
					next(_before: Address = null, _pagesize: number = 10): Promise<Address[]> {
						return new Promise((resolve, reject) => {
							console.debug('[ControlPanel.contactPaginator.next()] Caricati nuovi contatti..')
							self.addresses.indexOwned(
								self.auth.id,
								AddressOwnerType.USER,
								AddressType.CONTACT,
								null,
								1000,
							).then((addresses) => {
								resolve(addresses)
								self.detectChanges()
							}).catch(e => {
								console.error('Errore caricando i contatti dell\'utente')
								reject(e)
							})
						})
					}
				}
				self.detectChanges()
			}).catch(error => {
				//console.error("Errore recuperando i dati utente dal server:", error);
				Logger.error('Errore recuperando i dati dell\'utente autenticato dal server', error, 'ControlPanelPage.refresh()')
				self.isHousingUnitsLoading = false
				//self.refreshMessages();
				let toast = self.toastCtrl.create({
					message: "Errore recuperando i tuoi dati dal server",
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			})
	}
}



// WEBPACK FOOTER //
// ./src/pages/control-panel/control-panel.ts